// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"training-plans-box_wrapper__tGHcR","content":"training-plans-box_content__z4g8Y"};